/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { defineComponent, computed, provide, createVNode, TransitionGroup } from 'vue';
import props from './props.mjs';
import '../hooks/useConfig.mjs';
import { useTNodeDefault } from '../hooks/tnode.mjs';
import { useCLASSNAMES, injectKey } from './constants.mjs';
import useTree from './useTree.mjs';
import useExposeFunc from './hooks/useExposeFunc.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-1ec078b3.mjs';
import '../_chunks/dep-558fadc3.mjs';
import './tree-item.mjs';
import '../_chunks/dep-44e322cb.mjs';
import 'tdesign-icons-vue-next';
import '../checkbox/index.mjs';
import '../checkbox/checkbox.mjs';
import '../checkbox/props.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../utils/set-style.mjs';
import '../checkbox/constants.mjs';
import '../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../_common/js/utils/observe.mjs';
import '../checkbox/hooks/useKeyboard.mjs';
import '../hooks/useDisabled.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../config-provider/type.mjs';
import '../checkbox/group.mjs';
import '../_chunks/dep-be6b014c.mjs';
import '../_chunks/dep-e583fb66.mjs';
import '../_chunks/dep-a059cf4b.mjs';
import '../_chunks/dep-9a7888c7.mjs';
import '../checkbox/checkbox-group-props.mjs';
import '../hooks/slot.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../checkbox/type.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-b9505f3d.mjs';
import '../_chunks/dep-51567b45.mjs';
import '../_chunks/dep-af8c0169.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../loading/type.mjs';
import './util.mjs';
import '../_chunks/dep-e524ff2f.mjs';
import '../_chunks/dep-16b9f817.mjs';
import '../_chunks/dep-6c1f8553.mjs';
import '../_chunks/dep-437754aa.mjs';
import '../_chunks/dep-6dbd6c24.mjs';
import '../hooks/useGlobalIcon.mjs';
import './hooks/useDraggable.mjs';
import '../_chunks/dep-3bc637e0.mjs';
import '../_chunks/dep-a861ee00.mjs';
import '../_chunks/dep-3514a375.mjs';
import '../_common/js/tree/tree-store.mjs';
import '../_chunks/dep-c6ef2029.mjs';
import '../_chunks/dep-534b0779.mjs';
import 'mitt';
import '../_common/js/tree/tree-node.mjs';
import '../_chunks/dep-4c1d0ada.mjs';
import '../_chunks/dep-2bbbe05a.mjs';
import '../_chunks/dep-154ff253.mjs';
import '../_common/js/tree/tree-node-model.mjs';
import '../_chunks/dep-ad4331e8.mjs';
import '../_chunks/dep-e40749a5.mjs';
import '../_common/js/log/log.mjs';
import '../_common/js/log/index.mjs';
import '../hooks/useDefaultValue.mjs';
import './hooks/useOnDrag.mjs';

var _TdTree = defineComponent({
  name: "TTree",
  props: props,
  setup: function setup(props2, _ref) {
    var expose = _ref.expose,
      slots = _ref.slots;
    var _useConfig = useConfig("tree"),
      globalConfig = _useConfig.globalConfig,
      t = _useConfig.t;
    var CLASS_NAMES = useCLASSNAMES();
    var renderTNodeJSX = useTNodeDefault();
    var statusContext = computed(function () {
      var checkProps = props2.checkProps,
        empty = props2.empty,
        icon = props2.icon,
        label = props2.label,
        line = props2.line,
        disableCheck = props2.disableCheck,
        operations = props2.operations;
      return {
        checkProps: checkProps,
        empty: empty,
        icon: icon,
        label: label,
        line: line,
        disableCheck: disableCheck,
        operations: operations,
        scopedSlots: slots
      };
    });
    provide(injectKey, statusContext);
    var _useTree = useTree(props2),
      treeStore = _useTree.treeStore,
      treeNodeViews = _useTree.treeNodeViews;
    useExposeFunc(treeStore, expose);
    var classList = computed(function () {
      var _ref2;
      return [CLASS_NAMES.value.tree, (_ref2 = {}, _defineProperty(_ref2, CLASS_NAMES.value.disabled, props2.disabled), _defineProperty(_ref2, CLASS_NAMES.value.treeHoverAble, props2.hover), _defineProperty(_ref2, CLASS_NAMES.value.treeCheckable, props2.checkable), _defineProperty(_ref2, CLASS_NAMES.value.treeTransition, props2.transition), _defineProperty(_ref2, CLASS_NAMES.value.treeBlockNode, props2.expandOnClickNode), _ref2)];
    });
    return function () {
      return createVNode("div", {
        "class": classList.value
      }, [treeNodeViews.value.length === 0 ? createVNode("div", {
        "class": CLASS_NAMES.value.treeEmpty
      }, [renderTNodeJSX("empty", {
        defaultNode: t(globalConfig.value.empty)
      })]) : createVNode(TransitionGroup, {
        "name": CLASS_NAMES.value.treeNodeToggle,
        "tag": "div",
        "enter-active-class": CLASS_NAMES.value.treeNodeEnter,
        "leave-active-class": CLASS_NAMES.value.treeNodeLeave
      }, {
        "default": function _default() {
          return [treeNodeViews.value];
        }
      })]);
    };
  }
});

export { _TdTree as default };
//# sourceMappingURL=td-tree.mjs.map
